import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconLockLine, IconUnlockLine } from '@instructure/ui-icons';
import { Tooltip } from '@instructure/ui-tooltip';
import { IconButton } from '@instructure/ui-buttons';
import t from '@instructure/quiz-i18n/format-message';
var LockChoiceButton = /*#__PURE__*/function (_Component) {
  function LockChoiceButton() {
    var _this2;
    _classCallCheck(this, LockChoiceButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, LockChoiceButton, [].concat(args));
    _defineProperty(_this2, "handleClick", function () {
      _this2.props.onToggle(_this2.props.choiceId);
    });
    return _this2;
  }
  _inherits(LockChoiceButton, _Component);
  return _createClass(LockChoiceButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isLocked = _this$props.isLocked,
        choiceId = _this$props.choiceId;
      var icon = isLocked ? /*#__PURE__*/React.createElement(IconLockLine, null) : /*#__PURE__*/React.createElement(IconUnlockLine, null);
      var tooltipText = isLocked ? t('Unlock Distractor Position') : t('Lock Distractor Position');
      return /*#__PURE__*/React.createElement(Tooltip, {
        name: choiceId,
        renderTip: tooltipText,
        placement: "start"
      }, /*#__PURE__*/React.createElement(IconButton, {
        renderIcon: icon,
        withBackground: false,
        withBorder: false,
        onClick: this.handleClick,
        disabled: this.props.disabled,
        screenReaderLabel: this.props.screenReaderText,
        "data-automation": "sdk-lock-distractor-position-".concat(choiceId, "-button")
      }));
    }
  }]);
}(Component);
_defineProperty(LockChoiceButton, "propTypes", {
  choiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  isLocked: PropTypes.bool,
  onToggle: PropTypes.func,
  screenReaderText: PropTypes.string.isRequired
});
_defineProperty(LockChoiceButton, "defaultProps", {
  choiceId: void 0,
  disabled: false,
  isLocked: false,
  onToggle: Function.prototype
});
export { LockChoiceButton as default };